/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarBodyTypeFromJSON, CarBodyTypeToJSON, CarPaintProtectionTypeFromJSON, CarPaintProtectionTypeToJSON, DriveTypeFromJSON, DriveTypeToJSON, FuelTypeFromJSON, FuelTypeToJSON, GearTypeFromJSON, GearTypeToJSON, PaintEffectTypeFromJSON, PaintEffectTypeToJSON, } from './';
export function CarHistoryCarInfoFromJSON(json) {
    return CarHistoryCarInfoFromJSONTyped(json, false);
}
export function CarHistoryCarInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'makeName': !exists(json, 'makeName') ? undefined : json['makeName'],
        'modelName': !exists(json, 'modelName') ? undefined : json['modelName'],
        'manufactureYear': !exists(json, 'manufactureYear') ? undefined : json['manufactureYear'],
        'currentMileage': !exists(json, 'currentMileage') ? undefined : json['currentMileage'],
        'plateNumber': !exists(json, 'plateNumber') ? undefined : json['plateNumber'],
        'vin': !exists(json, 'vin') ? undefined : json['vin'],
        'engineOil': !exists(json, 'engineOil') ? undefined : json['engineOil'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'engineCapacity': !exists(json, 'engineCapacity') ? undefined : json['engineCapacity'],
        'maxSpeed': !exists(json, 'maxSpeed') ? undefined : json['maxSpeed'],
        'mass': !exists(json, 'mass') ? undefined : json['mass'],
        'acceleration': !exists(json, 'acceleration') ? undefined : json['acceleration'],
        'paintEffectType': !exists(json, 'paintEffectType') ? undefined : PaintEffectTypeFromJSON(json['paintEffectType']),
        'drive': !exists(json, 'drive') ? undefined : DriveTypeFromJSON(json['drive']),
        'gear': !exists(json, 'gear') ? undefined : GearTypeFromJSON(json['gear']),
        'firstRegistration': !exists(json, 'firstRegistration') ? undefined : (json['firstRegistration'] === null ? null : new Date(json['firstRegistration'])),
        'bodyType': !exists(json, 'bodyType') ? undefined : CarBodyTypeFromJSON(json['bodyType']),
        'paintProtection': !exists(json, 'paintProtection') ? undefined : CarPaintProtectionTypeFromJSON(json['paintProtection']),
        'fuelType': !exists(json, 'fuelType') ? undefined : FuelTypeFromJSON(json['fuelType']),
    };
}
export function CarHistoryCarInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'makeName': value.makeName,
        'modelName': value.modelName,
        'manufactureYear': value.manufactureYear,
        'currentMileage': value.currentMileage,
        'plateNumber': value.plateNumber,
        'vin': value.vin,
        'engineOil': value.engineOil,
        'enginePower': value.enginePower,
        'engineCapacity': value.engineCapacity,
        'maxSpeed': value.maxSpeed,
        'mass': value.mass,
        'acceleration': value.acceleration,
        'paintEffectType': PaintEffectTypeToJSON(value.paintEffectType),
        'drive': DriveTypeToJSON(value.drive),
        'gear': GearTypeToJSON(value.gear),
        'firstRegistration': value.firstRegistration === undefined ? undefined : (value.firstRegistration === null ? null : value.firstRegistration.toISOString()),
        'bodyType': CarBodyTypeToJSON(value.bodyType),
        'paintProtection': CarPaintProtectionTypeToJSON(value.paintProtection),
        'fuelType': FuelTypeToJSON(value.fuelType),
    };
}
